import React from 'react';
import Grid from '@material-ui/core/Grid';

const wrapper_main = props => {
  return <Grid container spacing={0}>
    { props.children }
  </Grid>
}

export default wrapper_main;
